export enum Brand {
	CAIWAY = 'CAIWAY',
	DELTA = 'DELTA',
	DELTA_CORPORATE = 'DELTA_CORPORATE'
}
